import './Component1.css'
import React from 'react'

const Component1 = () => {
  return (
    <div className='main-1-div'>
        <h1 className='h1-1'>COMPONENT - 1__</h1>
    </div>
  )
}

export default Component1